import React, { useState, useEffect } from 'react'
import './InstitutionList.css';
import { BiPlusMedical, BiSearchAlt } from 'react-icons/bi';
import { GoCloudDownload } from 'react-icons/go';
import { AiOutlineFileExcel } from 'react-icons/ai';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { getInstitutions } from '../../services/http';
import CustomDatatableInstitution from '../../components/CustomDatatableInstitution/CustomDatatableInstitution';
import { handleMenuSelection, handleSubMenuSelection, searchFunction, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';


const InstitutionList = () => {

  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Libellé" },
    { id: "3", label: "Catégorie" },
    { id: "4", label: "Email" },
    { id: "5", label: "Téléphone" },
    { id: "6", label: "Zone" }
  ]

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");
  const [displayLoader, setDisplayLoader] = useState(true);

  const states = useSelector((state) => state, shallowEqual);

  // To populate the breadcrumb and update the sidebar menu
  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Institutions", secondLevelLink: "/institution", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("institutions", dispatch)
  }, [])

  const fetchInstitutions = async (page, search) => {
    let institution_list_response = await getInstitutions(states.userToken.access_token, page, search);
    let institution_list_response_copy = institution_list_response?.data.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    console.log(institution_list_response_copy)
    const perPageValue = institution_list_response?.data?.per_page
    setPerPage(perPageValue)
    const total = institution_list_response?.data?.total;
    setTotalPage(Math.ceil(total / perPageValue))
    dispatch({
      type: "SET",
      key: "institutionList",
      payload: institution_list_response_copy,
    });
    setDisplayLoader(false);
  }
  useEffect(() => {
    fetchInstitutions(pageNumber, search)
    console.log(pageNumber)
    console.log(search)
  }, [pageNumber, search])



  const goToImportScreen = () => {
    navigate("/import-institution")
  }

  const handleShowNewCatModal = () => {
    navigate("/institution/new")
  };

  const handleCloseDeleteModal = (id) => {
    let index = states.institutionList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.institutionList];
    newTableData[index].showDelete = false;

    dispatch({
      type: "SET",
      key: "institutionList",
      payload: newTableData,
    });
  };
  const handleShowDeleteModal = (id) => {
    let index = states.institutionList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.institutionList];
    newTableData[index].showDelete = true;
    dispatch({
      type: "SET",
      key: "institutionList",
      payload: newTableData,
    });
  };

  const changePage = ({ selected }) => {

    let currentPage = selected + 1;
    setPageNumber(currentPage)
  }

  const handleSearchChange = (e) => {
    console.log(e.currentTarget.value)
    setSearch(e.currentTarget.value)

  }

  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing mb-4">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {/* <AddOrEditInstitutionCategory onExit={reload} operationType={"new"} show={states.showNewInstitutionCategory} handleClose={handleCloseNewCatModal} /> */}
            <h2 className="mb-3 text-left">Liste des institutions</h2>
            {displayLoader == false ?
            <div className="widget widget-content widget-content-area">
              <div className="dataTables_wrapper  dt-bootsrap4">
                <div className="dt--top-section container-fluid my-4 pt-3 px-3">
                  <div className="row">
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center">
                      <form class="form-inline justify-content-center search-input-container mb-3">
                        <div class="w-100 d-flex flex-nowrap search-input-container">
                          <input type="text" onChange={handleSearchChange} class=" form-control product-search br-30" id="input-search" placeholder="Rechercher..." />

                        </div>
                      </form>
                    </div>
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mt-sm-0 mt-3">
                      {states.userPermissions?.create_institution !== undefined && <div>
                        <button className="btn btn-info mb-2" onClick={() => handleShowNewCatModal()}> <BiPlusMedical className="" /> Ajouter</button>
                        <button className="btn btn-dark ml-3 mb-2" onClick={goToImportScreen}><AiOutlineFileExcel className="mr-1" />Importer</button>
                      </div>}
                    </div>
                  </div>
                </div>


                {states.institutionList && states.institutionList?.length !== 0 ? <CustomDatatableInstitution columns={tableColumns}
                  data={states.institutionList}
                  handleCloseDeleteModal={handleCloseDeleteModal}
                  handleShowDeleteModal={handleShowDeleteModal}
                  changePage={changePage}
                  pageCount={totalPage}
                  pageNumber={pageNumber}
                  perPage={perPage}
                /> : <h4 className="py-3">Aucun résultat</h4>}
              </div>
            </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}
          </div>

        </div>
      </div>
    </div>
  )
}

export default InstitutionList

